import { Component, Input } from '@angular/core';

@Component({
    selector: 'latest-posts-placeholder',
    templateUrl: './latest-posts-placeholder.component.html',
    styleUrls: ['./latest-posts-placeholder.component.scss']
})
export class LatestPostsPlacholderComponent {
    public posts = Array.from(Array(10).keys());

    @Input() printMode: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-posts-placeholder/latest-posts-placeholder.component.ts